<div class="btn-section m-b-xl">
  <button
    id="tmo-button-purchase-device-only"
    class="btn btn-primary"
    (click)="selectPurchaseDeviceOnly(true)"
  >
    {{ isNewPlansPageEnabled ? aemContent?.iDontNeedAPlan : aemContent?.purchaseDeviceOnly }}
  </button>
</div>
